import React, { Component, useLayoutEffect } from 'react';
import * as PropTypes from 'prop-types';
import loadScript from 'load-script';
import './Unity.sass';

import Unity from 'react-unity-webgl';
import Spinner from 'react-bootstrap/Spinner';

/**
 * IMPORTANT: The UnityContext class instance is attached to the window, instead of Redux state, since
 * it is a mutable class instance. Redux cautions against having such objects in state:
 *   "Avoid putting non-serializable values such as Promises, Symbols, Maps/Sets, functions, or class instances
 *    into the Redux store state or dispatched actions. This ensures that capabilities such as debugging via
 *    the Redux DevTools will work as expected. It also ensures that the UI will update as expected."
 * Look for it on window._unityContext instead.
 */

const UnityWebGL = ({ webglPath, unityContextInitialized, unityIsLoading }) => {

  useLayoutEffect(() => {
    const observer = new MutationObserver(() => {
      const canvas = document.querySelector("canvas.unity-player");

      if (canvas) {
        canvas.setAttribute("aria-label", "This is a visual 3D modeling application that does not support screen readers. Buttons and tools will not be announced."); 
        
        const handler = (e) => {
          if (e.key === "Tab") {
            if (e.shiftKey) {
              // Let Shift+Tab escape normally
              return;
            }
            // Prevent forward Tab so Unity keeps focus
            e.preventDefault();
            canvas.focus(); 
          }
          if (e.key === "Enter") {
            // Prevent browser default (like clicking a button)
            //e.preventDefault();
          }
        };

        canvas.addEventListener("keydown", handler);
        observer.disconnect(); // stop watching once we’ve found the canvas
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  
  if (!unityContextInitialized) {
    return (
      <div>
        <div
          style={{
            color: '#fff',
            padding: '10px',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Spinner animation="border" size="md" className="me-3" />
          The 3D engine is loading, please wait...
        </div>
      </div>
    );
  } else {
    return (
      <>
        {unityIsLoading && (
          <div style={{ position: 'absolute' }}>
            <div
              style={{
                color: '#fff',
                padding: '10px',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Spinner animation="border" size="md" className="me-3" />
              The 3D engine is loading, please wait...
            </div>
          </div>
        )}
        <Unity
          unityContext={window._unityContext}
          className="box unity-player"
          devicePixelRatio={1}
          tabIndex={1}
        />
      </>
    );
  }
};
export default UnityWebGL;

UnityWebGL.defaultProps = {
  unityContextInitialized: false,
};
UnityWebGL.propTypes = {
  unityContextInitialized: PropTypes.bool,
};
